import Swal from 'sweetalert2';

export const PMR_SWAL_SUCCESS_SVG = `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="var(--pmr-white)" stroke="var(--pmr-swal-success-stroke)" stroke-width="2" />
    <path d="M18 28L25 35L38 22" stroke="var(--pmr-swal-success-stroke)" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const PMR_SWAL_ERROR_SVG = `
  <svg width="48" height="48" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="none" stroke="var(--pmr-status-error)" stroke-width="2" />
    <path d="M18 18L38 38M38 18L18 38" stroke="var(--pmr-status-error)" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const PMR_SWAL_WARNING_SVG = `
  <svg width="48" height="48" viewBox="0 0 56 56" fill="none">
    <circle cx="28" cy="28" r="27" fill="none" stroke="var(--pmr-status-warning)" stroke-width="2" />
    <path d="M28 18v16M28 40h.01" stroke="var(--pmr-status-warning)" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

function fixSwalIconStyles() {
  document.querySelectorAll('.pmr-swal-status .swal2-icon, .swal2-success-custom .swal2-icon, .swal2-info-custom .swal2-icon').forEach((el) => {
    el.style.borderColor = 'transparent';
    el.style.borderWidth = '0';
    el.style.boxShadow = 'none';
    el.style.display = 'flex';
    el.style.alignItems = 'center';
    el.style.justifyContent = 'center';
    el.style.textAlign = 'center';
    el.style.left = 'auto';
    el.style.right = 'auto';
    el.style.float = 'none';

    if (el.closest('.pmr-swal-status')) {
      // Keep peach header background from CSS; only clear SA2 ring styles
      el.style.backgroundColor = '';
      el.style.background = '';
    } else {
      el.style.background = 'transparent';
    }

    const content = el.querySelector('.swal2-icon-content');
    if (content) {
      content.style.display = 'flex';
      content.style.alignItems = 'center';
      content.style.justifyContent = 'center';
      content.style.margin = '0 auto';
      content.style.fontSize = '0';
      content.style.lineHeight = '0';
      content.style.position = 'static';
      content.style.transform = 'none';
    }
  });
}

const statusPopupClass = { popup: 'pmr-swal-status' };

export function showPmrSuccess(options) {
  const config = typeof options === 'string' ? { message: options } : options;
  const { message, html, title, timer = 2000, onClose, customClass } = config;
  const resolvedTitle = title === undefined ? 'Success!' : title;

  const { popup: extraPopupClass, ...restCustomClass } = customClass || {};
  const popupClass = ['swal2-success-custom', extraPopupClass].filter(Boolean).join(' ');

  return Swal.fire({
    iconHtml: PMR_SWAL_SUCCESS_SVG,
    title: resolvedTitle,
    html: html || `<div style="color:var(--pmr-text);font-size:16px;">${message || ''}</div>`,
    confirmButtonText: 'OK',
    customClass: { popup: popupClass, ...restCustomClass },
    confirmButtonColor: 'var(--pmr-btn-primary)',
    showConfirmButton: true,
    timer: timer || undefined,
    didOpen: fixSwalIconStyles,
  }).then((result) => {
    if (onClose) onClose(result);
    return result;
  });
}

export function showPmrError(options) {
  const config = typeof options === 'string' ? { message: options } : options;
  const { message, title, html, onClose, timer } = config;
  const hasTitle = Boolean(title);

  return Swal.fire({
    icon: 'error',
    iconHtml: PMR_SWAL_ERROR_SVG,
    title: hasTitle ? title : undefined,
    html: html || `<div style="color:var(--pmr-text);font-size:16px;">${message || ''}</div>`,
    confirmButtonText: 'OK',
    customClass: {
      popup: hasTitle ? 'pmr-swal-status pmr-swal-status-titled' : 'pmr-swal-status pmr-swal-status-error',
    },
    confirmButtonColor: 'var(--pmr-btn-primary)',
    timer: timer || undefined,
    heightAuto: false,
    scrollbarPadding: false,
    returnFocus: false,
    didOpen: fixSwalIconStyles,
  }).then((result) => {
    if (onClose) onClose(result);
    return result;
  });
}

export function showPmrWarning(options) {
  const config = typeof options === 'string' ? { message: options } : options;
  const { message, html, onClose } = config;

  return Swal.fire({
    icon: 'warning',
    iconHtml: PMR_SWAL_WARNING_SVG,
    html: html || `<div style="color:var(--pmr-text);font-size:16px;">${message || ''}</div>`,
    confirmButtonText: 'OK',
    customClass: { popup: 'pmr-swal-status pmr-swal-status-warning' },
    confirmButtonColor: 'var(--pmr-btn-primary)',
    didOpen: fixSwalIconStyles,
  }).then((result) => {
    if (onClose) onClose(result);
    return result;
  });
}

export function showPmrConfirm({
  title,
  message,
  html,
  confirmText = 'Yes',
  cancelText = 'No',
  confirmButtonColor = 'var(--pmr-btn-primary)',
  cancelButtonColor = 'var(--pmr-btn-primary)',
  allowOutsideClick,
  allowEscapeKey,
  customClass = {},
}) {
  const messageHtml = html || (message
    ? `<div style="color:var(--pmr-text);font-size:16px;">${message}</div>`
    : undefined);

  const { popup: extraPopupClass, ...restCustomClass } = customClass || {};
  const popupClass = ['swal2-delete-custom', extraPopupClass].filter(Boolean).join(' ');

  return Swal.fire({
    title,
    html: messageHtml,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor,
    cancelButtonColor,
    customClass: { popup: popupClass, ...restCustomClass },
    allowOutsideClick,
    allowEscapeKey,
  });
}

export function showPmrDeleteConfirm(options) {
  const config = typeof options === 'string' ? { message: options } : options;
  const messageHtml = config.html || (config.message
    ? `<div style="color:var(--pmr-text);font-size:16px;">${config.message}</div>`
    : undefined);

  return Swal.fire({
    icon: 'warning',
    title: config.title || 'Are you sure?',
    html: messageHtml,
    showCancelButton: true,
    confirmButtonText: config.confirmText || 'Yes, delete it!',
    cancelButtonText: config.cancelText || 'Cancel',
    confirmButtonColor: 'var(--pmr-danger)',
    cancelButtonColor: 'var(--pmr-btn-primary)',
    customClass: { popup: 'swal2-delete-custom' },
  });
}
